import { AirportMarketFilter } from './airports';
import { AirportType } from '../_commons/locations';

export function prepareAirportForMarket(airport = {}, airportType, filterFields = 'NONE') {
  const { filterFields: filterFieldsOption } = airport;
  if (!filterFieldsOption && filterFields !== AirportMarketFilter.NONE) {
    console.error('** NO_FILTER_FIELDS_ADDED_IN_CONFIGURATION**');
  }

  let resultAirPort = { ...airport };

  switch (filterFields.toUpperCase()) {
    case AirportMarketFilter.NONE:
      delete resultAirPort.filterFields;
      break;
    case AirportMarketFilter.ALL:
      break;
    case AirportMarketFilter.ORIGIN:
      if (airportType !== AirportType.ORIGIN) {
        delete resultAirPort.filterFields;
      }
      break;
    case AirportMarketFilter.DESTINATION:
      if (airportType !== AirportType.DESTINATION) {
        delete resultAirPort.filterFields;
      }
      break;
    default:
  }

  if (resultAirPort.filterDestination) {
    if (airportType !== AirportType.DESTINATION) {
      delete resultAirPort.filterDestination;
    } else {
      resultAirPort = { ...resultAirPort, filterFields: resultAirPort.filterDestination };
      delete resultAirPort.filterDestination;
    }
  }

  return resultAirPort;
}
